<template>
    <div class="row">
        <div
            v-for="recipe in recipes"
            v-bind:key="recipe.id"
            class="col-sm-4 mb-4"
        >
            <recipe-card :recipe="recipe" :show_category="1"></recipe-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "HomepageRecipes",
    props: ["recipes"],
    data() {},
};
</script>
<style scoped></style>
